(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jp-dashain-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jp-dashain-carousel')) {
    customElements.define('jp-dashain-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.offset = 0;
        this.track = this.querySelector('[data-dashain-cards]');
        this.cards = Array.from(this.track.children);
        this.previous = this.querySelector('[data-dashain-prev]');
        this.next = this.querySelector('[data-dashain-next]');
        this.count = this.querySelector('[data-dashain-count]');
        this.navigation = this.querySelector('[data-dashain-navigation]');
        this.mobile = window.matchMedia('(max-width: 749px)');
        const options = { signal: this.abort.signal };
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
          if (!this.mobile.matches || index < 0) return;
          this.offset = Math.min(index, Math.max(0, this.cards.length - 2));
          this.render();
        }, options);
        this.previous.addEventListener('click', () => this.step(-1), options);
        this.next.addEventListener('click', () => this.step(1), options);
        this.track.addEventListener('keydown', event => {
          if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.step(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.track.addEventListener('dragstart', event => { if (this.mobile.matches) event.preventDefault(); }, options);
        this.track.addEventListener('pointerdown', event => {
          if (!this.mobile.matches || !event.isPrimary) return;
          this.start = { x: event.clientX, y: event.clientY, id: event.pointerId };
        }, options);
        this.track.addEventListener('pointermove', event => {
          if (!this.start || this.start.id !== event.pointerId) return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) && !this.track.hasPointerCapture(event.pointerId)) this.track.setPointerCapture(event.pointerId);
        }, options);
        this.track.addEventListener('pointerup', event => {
          if (!this.start || this.start.id !== event.pointerId) return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
            this.suppressClickUntil = Date.now() + 350;
            this.step(dx > 0 ? 1 : -1);
          }
        }, options);
        this.track.addEventListener('pointercancel', () => { this.start = null; }, options);
        this.track.addEventListener('click', event => {
          if (Date.now() < (this.suppressClickUntil || 0)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, options);
        this.onResize = () => this.render();
        this.mobile.addEventListener('change', this.onResize);
        this.render();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.mobile?.removeEventListener('change', this.onResize);
      }
      step(direction) {
        this.offset = Math.max(0, Math.min(Math.max(0, this.cards.length - 2), this.offset + direction));
        this.render();
      }
      render() {
        const mobile = this.mobile.matches;
        this.cards.forEach((card, index) => { card.hidden = mobile && (index < this.offset || index > this.offset + 1); });
        this.previous.disabled = this.offset === 0;
        this.next.disabled = this.offset >= this.cards.length - 2;
        this.navigation.hidden = !mobile || this.cards.length <= 2;
        this.track.tabIndex = mobile && this.cards.length > 2 ? 0 : -1;
        this.count.textContent = this.dataset.countTemplate.replace('[start]', String(this.offset + 1)).replace('[end]', String(Math.min(this.offset + 2, this.cards.length))).replace('[total]', String(this.cards.length));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
